import { useMemo } from 'react';
import { useTableSelector } from '../../redux/reduxHooks';
import { getIsQuerySelected, getSelectedRowIds } from '../../selection/redux/selectionSlice';
export function useShowSelectQuery(rows, getRowId, canSelectAllRecords, isBulkActionsRedesignEnabled, totalRowCount) {
  const isQuerySelected = useTableSelector(getIsQuerySelected);
  const currentPageRowIds = useMemo(() => rows.map(getRowId), [getRowId, rows]);
  const isCurrentPageSelected = useIsCurrentPageSelected(currentPageRowIds);
  const hasMorePages = totalRowCount > currentPageRowIds.length;
  const canSelectQuery = canSelectAllRecords && isCurrentPageSelected && hasMorePages;
  const showSelectQueryRow = canSelectQuery && !isBulkActionsRedesignEnabled;
  const showSelectQueryInBulkActionsContainer = canSelectQuery && !isQuerySelected && isBulkActionsRedesignEnabled;
  return {
    showSelectQueryRow,
    showSelectQueryInBulkActionsContainer
  };
}
function useIsCurrentPageSelected(currentPageRowIds) {
  const selectedRowIds = useTableSelector(getSelectedRowIds);
  if (currentPageRowIds.length === 0) {
    return false;
  }
  return currentPageRowIds.every(rowId => selectedRowIds.has(rowId));
}